import React from 'react';
import SectionTitle from './common/SectionTitle';

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: "DMS Web Platform",
      description: "Manage your entire distribution operation from the web dashboard"
    },
    {
      number: 2,
      title: "MSP Mobile App",
      description: "Equip your sales team with the mobile app for field operations"
    },
    {
      number: 3,
      title: "Retailer Portal",
      description: "Enable retailers to place orders directly through their portal"
    },
    {
      number: 4,
      title: "Data Sync",
      description: "All data syncs in real-time across all platforms"
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <SectionTitle 
          title="The SellWise360 Ecosystem"
          subtitle="Integrated solutions that work together seamlessly"
        />
        <div className="steps">
          {steps.map((step, index) => (
            <div className="step" key={index}>
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
        <div className="architecture-diagram">
          {/* <img src="/images/system-architecture.png" alt="SellWise System Architecture" /> */}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;